import { useCallback, useEffect, useState } from 'react';
import { applyThemeAttribute, readAccentGradient, readStoredTheme, storeTheme } from '../lib/theme.js';

// Applies the theme to <html> and tracks the accent gradient shown in the nav dot.
//
// The gradient has to be read *after* the browser has recalculated styles for
// the new data-theme, hence the rAF hop — reading synchronously returns the
// outgoing theme's accents.
export function useTheme() {
  const [theme, setTheme] = useState(readStoredTheme);
  const [accentGradient, setAccentGradient] = useState('');

  useEffect(() => {
    applyThemeAttribute(theme);
    const raf = requestAnimationFrame(() => setAccentGradient(readAccentGradient()));
    return () => cancelAnimationFrame(raf);
  }, [theme]);

  const chooseTheme = useCallback((id) => {
    setTheme(id);
    storeTheme(id);
  }, []);

  return { theme, chooseTheme, accentGradient };
}
